import React, { useEffect, useRef } from "react";
import classNames from "classnames";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faPencil } from "@fortawesome/free-solid-svg-icons";

import { extractValue } from "$components/form-inputs/libs/helpers";
import { scrollIntoViewIfNeeded } from "$components/form-inputs/libs/scroll-into-view";
import { dialogConfirm } from "$stores/modal";

const SelectItem = ({ isActiveIndex, item, selected, updateValues, updateOption, EditComponent }) => {
    const dropdownItem = useRef();
    const isSelected = extractValue(item) === extractValue(selected) ? true : false;

    useEffect(() => {
        if (isActiveIndex) {
            scrollIntoViewIfNeeded(dropdownItem.current);
        }
    }, [isActiveIndex]);

    const updateOnChange = (e) => {
        e.stopPropagation();
        e.preventDefault();
        updateValues(item, !isSelected);
    };

    const handleUpdateItem = async () => {
        const confirmUpdate = await dialogConfirm({
            Component: EditComponent,
            data: {
                message: item.text,
                data: item,
            },
            settings: {
                type: "confirm",
            },
        });

        if (confirmUpdate) {
            updateOption(item, confirmUpdate);
        }
    };

    return (
        <li className="-flex" ref={dropdownItem}>
            <a href="#selectItem" className={classNames({ "-active": isActiveIndex })} tabIndex="-1" aria-selected={isActiveIndex} role="option" onClick={updateOnChange}>
                {isSelected && <span className="checkmark"></span>}
                {typeof item === "string" ? item : item.text}
            </a>
            {updateOption && (
                <a href="#updateItem" onClick={handleUpdateItem}>
                    <FontAwesomeIcon icon={faPencil} />
                </a>
            )}
        </li>
    );
};

export default SelectItem;
